const createModulePrompts = [
    {
        type: 'list',
        name: 'moduleName',
        message: 'Module name !',
        choices: [
            { name: 'Security', value: 'security' },
            { name: 'Administration', value: 'administration' },
            { name: 'Comptability', value: 'comptability' },
            { name: 'Order management', value: 'order-management' },
            { name: 'Other', value: 'other' },
        ],
    },
    {
        type: 'input',
        name: 'modelName',
        message: 'Model name !',
    },
];

export default createModulePrompts;
